<template>
  <div>
    <div class="weui-msg">
      <div class="title">校圆通</div>
      <div v-if="errorCode == '10005'">
        <div class="sub-title">&gt;&gt;&gt; 长按识别关注 &lt;&lt;&lt;</div>
        <div class="qrcode">
          <img src="./../../static/qrcode.jpg" />
        </div>
        <div class="error">{{ errorMsg }}</div>
      </div>
      <div v-else>
        <div class="sub-title">&gt;&gt;&gt; 出错了 &lt;&lt;&lt;</div>
        <div class="qrcode">
          <img src="./../../static/error.png" />
        </div>
        <div class="error">{{ errorMsg }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      errorCode: "",
      errorMsg: "",
      year: moment().format("YYYY"),
    };
  },
  created() {
    this.errorCode = this.$route.params.errorCode;
    /**
     * '10000': '微信授权失败',
     * '10001': '找到不对应的用户信息',
     * '10002': '获取微信头像编码出错',
     * '10003': '找不到对应的订单信息',
     * '10004': '签名失败',
     * '10005': '请重新关注校圆通公众号'
     */
    if (this.errorCode == "10000") {
      this.errorMsg = "无法获取您的微信授权，请确认已授权或者稍后再试";
    } else if (this.errorCode == "10001") {
      this.errorMsg = "无法获取您的个人信息，请确认已授权或者稍后再试";
    } else if (this.errorCode == "10002") {
      this.errorMsg = "无法获取您的微信头像，请确认已授权或者稍后再试";
    } else if (this.errorCode == "10003") {
      this.errorMsg = "无法获取对应的订单信息";
    } else if (this.errorCode == "10004") {
      this.errorMsg = "调用微信接口数据签名失败";
    } else if (this.errorCode == "10005") {
      this.errorMsg =
        "为了给您提供更精准的贴心服务，请长按上方二维码关注校圆通公众号再试。";
    }
  },
};
</script>


<style scoped>
.title {
  font-size: 2rem;
  font-weight: bold;
}
.sub-title {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: #959595;
}
.weui-msg__icon-area {
  margin-bottom: 10px;
}
.weui-msg__text-area {
  margin-bottom: 0px;
}
.weui-msg__title {
  font-weight: bold;
  color: orangered;
}
.weui-msg__desc {
  color: orangered;
}
.qrcode {
  text-align: center;
}
.qrcode img {
  width: 250px;
  margin-bottom: 4rem;
}
.qrcode header {
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #1aad19;
  color: #fff;
  background-color: #1aad19;
  position: relative;
}
.error {
  font-size: 16px;
  margin-left: 30px;
  margin-right: 30px;
  color: #959595;
}
</style>




// WEBPACK FOOTER //
// src/components/Error.vue